<!--
  PersonalProfilePage -- the routed wrapper around the shared
  ProfileSettings component.

  Card: "Personal Profile page" -- https://trello.com/c/BxskXBad

  ONE page component, mounted by all four apps' profile routes:

    /admin/profile          (SuperAdmin chrome)
    /distributor/profile    (Distributor chrome)
    /portal/profile         (Client Portal chrome)
    /shop/:slug/profile     (Storefront chrome)

  Each route carries its own `meta.layout`, so App.vue wraps this page in
  that app's chrome and the page itself needs to know nothing about which
  app it is in -- which is the whole point of the shared component. The
  page exists (rather than routing straight at ProfileSettings) so each
  app gets a consistent heading and page frame without ProfileSettings
  having to render one, and so a future app-specific section could be
  slotted in beside the shared one without forking the component.

  ASCII-only.
-->
<template>
    <div class="personal-profile-page" data-testid="personal-profile-page">
        <h1 class="personal-profile-page__title">Profile</h1>
        <p class="personal-profile-page__subtitle">
            Your personal account details. These are yours alone -- changing
            them does not affect anyone else on your team.
        </p>

        <profile-settings />
    </div>
</template>

<script>
import ProfileSettings from "@/components/Profile/ProfileSettings.vue";

export default {
    name: "PersonalProfilePage",
    components: { ProfileSettings },
};
</script>

<style scoped>
.personal-profile-page {
    padding: 24px;
}

.personal-profile-page__title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 4px;
}

.personal-profile-page__subtitle {
    font-size: 0.875rem;
    color: var(--tf-color-text-muted, #666);
    margin: 0 0 24px;
    max-width: 560px;
}
</style>
